import React from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { Panel } from "@ui5/webcomponents-react";
import dayjs from 'dayjs';
import Box from '@mui/material/Box';
import axios from 'axios';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import { ScoreBadge } from './ScoreBadge';
import { useTheme } from '../utils/ThemeContext';


const ScoreCardPopup = ({datePlayed, scoreID, courseName, courseID, open, onClose}) => {
    const { theme } = useTheme();

    const [netData, setNetData] = React.useState([])
    const [grossData, setGrossData] = React.useState([])
    const [courseDataPar, setCourseDataPar] = React.useState([])
    const [courseDataHcp, setCourseDataHcp] = React.useState([])
    //const [loadingStats, setLoadingStats] = React.useState(false)
    const [handicap, setHandicap] = React.useState("")
    const [points, setPoints] = React.useState("")

    //get the needed data for the standings and stats
    React.useEffect(() => {
        //setLoadingStats(true)
        getData(scoreID, courseID)
    }, [scoreID, courseID])
  
  async function getData(scoreID, courseID) {
    axios.all([
        axios.get("api/scores/read_one.php?scoreID=" + scoreID),
        axios.get("api/courses/read.php?courseID=" + courseID)
    ])
    .then(axios.spread((obj1, obj2) => {
        //console.log(JSON.stringify(obj2.data))
        setNetData([obj1.data.net1, obj1.data.net2, obj1.data.net3, obj1.data.net4, obj1.data.net5, obj1.data.net6, obj1.data.net7, obj1.data.net8, obj1.data.net9, obj1.data.netTotal])
        setGrossData([obj1.data.gross1, obj1.data.gross2, obj1.data.gross3, obj1.data.gross4, obj1.data.gross5, obj1.data.gross6, obj1.data.gross7, obj1.data.gross8, obj1.data.gross9, obj1.data.grossTotal])
        setHandicap(obj1.data.handicap)
        setPoints(obj1.data.points)
        setCourseDataPar([obj2.data.records[0].par_1,
            obj2.data.records[0].par_2,
            obj2.data.records[0].par_3,
            obj2.data.records[0].par_4,
            obj2.data.records[0].par_5,
            obj2.data.records[0].par_6,
            obj2.data.records[0].par_7,
            obj2.data.records[0].par_8,
            obj2.data.records[0].par_9,
            obj2.data.records[0].par]) 
            setCourseDataHcp([obj2.data.records[0].men_hcp_1,
                obj2.data.records[0].men_hcp_2,
                obj2.data.records[0].men_hcp_3,
                obj2.data.records[0].men_hcp_4,
                obj2.data.records[0].men_hcp_5,
                obj2.data.records[0].men_hcp_6,
                obj2.data.records[0].men_hcp_7,
                obj2.data.records[0].men_hcp_8,
                obj2.data.records[0].men_hcp_9])
    })).catch((error) =>{
      console.error("Error fetching data: ", error)
    }).finally(() => {
      //setLoadingStats(false)
    })
  }


    return(
        <>
        <Popup
            // eslint-disable-next-line 
            {...(open !== undefined ? { open, onClose } : { trigger: <Tooltip title="View scorecard" placement="right" arrow><a href="#" style={{textDecoration: "none", color: theme.primary, fontWeight: 'bold'}}>{datePlayed}</a></Tooltip> })}
            modal
            nested
            contentStyle={{ width: '90%' }}
        >
            <Panel fixed={true} style={{backgroundColor: theme.panelBg}} headerText={courseName + ' - ' +  dayjs(datePlayed).format('MMMM D, YYYY')}>
            <Box pl={1} pt={1} pb={2}>
            <Stack direction="row">
                <Box pr={2}>
                    Handicap: {handicap}
                </Box>
                <Box>
                    Points: {points}
                </Box>
            </Stack>
            </Box>
                <Box pt={1} pl={1} pr={1} style={{ overflowX: 'auto', width: '100%', boxSizing: 'border-box' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', tableLayout: 'fixed' }}>
                        <tbody>
                        <tr style={{ backgroundColor: theme.primary, color: '#fff', fontWeight: 'bold' }}>
                            <td style={{ padding: '4px 2px', textAlign: 'left', width: '38px' }}></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center', width: '26px' }}>1</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center', width: '26px' }}>2</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center', width: '26px' }}>3</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center', width: '26px' }}>4</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center', width: '26px' }}>5</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center', width: '26px' }}>6</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center', width: '26px' }}>7</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center', width: '26px' }}>8</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center', width: '26px' }}>9</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center', width: '26px' }}>Tot</td>
                        </tr>
                        <tr style={{ backgroundColor: theme.rowBg }}>
                            <td style={{ padding: '4px 2px', textAlign: 'left', fontWeight: 'bold', color: theme.primary }}>Gross</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={grossData[0]} par={courseDataPar[0]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={grossData[1]} par={courseDataPar[1]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={grossData[2]} par={courseDataPar[2]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={grossData[3]} par={courseDataPar[3]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={grossData[4]} par={courseDataPar[4]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={grossData[5]} par={courseDataPar[5]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={grossData[6]} par={courseDataPar[6]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={grossData[7]} par={courseDataPar[7]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={grossData[8]} par={courseDataPar[8]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><span>{grossData[9]}</span></td>
                        </tr>
                        <tr style={{ backgroundColor: theme.rowBgAlt }}>
                            <td style={{ padding: '4px 2px', textAlign: 'left', fontWeight: 'bold', color: theme.primary }}>Hcp</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataHcp[0]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataHcp[1]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataHcp[2]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataHcp[3]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataHcp[4]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataHcp[5]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataHcp[6]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataHcp[7]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataHcp[8]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}></td>
                        </tr>
                        <tr style={{ backgroundColor: theme.rowBg }}>
                            <td style={{ padding: '4px 2px', textAlign: 'left', fontWeight: 'bold', color: theme.primary }}>Net</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={netData[0]} par={courseDataPar[0]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={netData[1]} par={courseDataPar[1]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={netData[2]} par={courseDataPar[2]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={netData[3]} par={courseDataPar[3]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={netData[4]} par={courseDataPar[4]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={netData[5]} par={courseDataPar[5]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={netData[6]} par={courseDataPar[6]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={netData[7]} par={courseDataPar[7]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><ScoreBadge score={netData[8]} par={courseDataPar[8]} zeroAsEagle /></td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}><span>{netData[9]}</span></td>
                        </tr>
                        <tr style={{ backgroundColor: theme.rowBgAlt }}>
                            <td style={{ padding: '4px 2px', textAlign: 'left', fontWeight: 'bold', color: theme.primary }}>Par</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataPar[0]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataPar[1]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataPar[2]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataPar[3]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataPar[4]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataPar[5]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataPar[6]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataPar[7]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataPar[8]}</td>
                            <td style={{ padding: '4px 0px', textAlign: 'center' }}>{courseDataPar[9]}</td>
                        </tr>
                        </tbody>
                    </table>
                </Box>
            </Panel>
        </Popup>
    </>
    )
    }

export default ScoreCardPopup